// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left img[data-v-330bdc99]{margin-left:10px;width:40px}.right h4[data-v-330bdc99]{margin:15px 0 5px}.right p[data-v-330bdc99]{font-size:14px;margin:5px 0 15px}[data-v-330bdc99]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
